// extracted by mini-css-extract-plugin
export default {"postcodeWrapper":"R7ysgBU23g","postcodeTextField":"jDTRpdqSz9","postcodeChange":"dHZ3NHyJbN"};